import {
  companyAuthorizationRoles,
  platformAuthorizationRoles,
  type AssignableAuthorizationRole,
} from "./access-control.js";

export const companyTypes = ["client", "vendor"] as const;
export type CompanyType = (typeof companyTypes)[number];

export const companyProjectAccessScopes = [
  "all_company_projects",
  "assigned_projects",
] as const;
export type CompanyProjectAccessScope = (typeof companyProjectAccessScopes)[number];

export type CompanyAuthorizationRole = (typeof companyAuthorizationRoles)[number];
export type PlatformAuthorizationRole = (typeof platformAuthorizationRoles)[number];

export const clientCompanyRoles = [
  "client_owner",
  "client_manager",
] as const satisfies readonly CompanyAuthorizationRole[];

export const vendorCompanyRoles = [
  "vendor_owner",
  "vendor_manager",
] as const satisfies readonly CompanyAuthorizationRole[];

export const globalAuthorizationRoles = [
  "independent_specialist",
  ...platformAuthorizationRoles,
] as const satisfies readonly AssignableAuthorizationRole[];

export type GlobalAuthorizationRole = (typeof globalAuthorizationRoles)[number];

export function isCompanyAuthorizationRole(
  role: AssignableAuthorizationRole,
): role is CompanyAuthorizationRole {
  return (companyAuthorizationRoles as readonly AssignableAuthorizationRole[]).includes(role);
}

export function isPlatformAuthorizationRole(
  role: AssignableAuthorizationRole,
): role is PlatformAuthorizationRole {
  return (platformAuthorizationRoles as readonly AssignableAuthorizationRole[]).includes(role);
}

export function isGlobalAuthorizationRole(
  role: AssignableAuthorizationRole,
): role is GlobalAuthorizationRole {
  return (globalAuthorizationRoles as readonly AssignableAuthorizationRole[]).includes(role);
}

export function companyRoleMatchesType(
  role: CompanyAuthorizationRole,
  companyType: CompanyType,
): boolean {
  const allowed = companyType === "client" ? clientCompanyRoles : vendorCompanyRoles;
  return (allowed as readonly CompanyAuthorizationRole[]).includes(role);
}
